import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotivationsViewComponent } from './motivations-view/motivations-view.component';
import { MoovCommonModule } from '../moov-common/moov-common.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    MotivationsViewComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MoovCommonModule,
    MatDialogModule,
    MatDividerModule,
    MatSidenavModule
  ],
  exports: [
    MotivationsViewComponent
  ], 
  providers : [
    { provide: MAT_DIALOG_DATA, useValue: {} },

  ]
})

export class AllMotivationsModule { }
